import Enum from '@square/dashboard-utilities/utils/enum';
import Employee from '@square/dashboard-data/models/squareup/bills/employee';
import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const ReminderOptions = new Enum(['NONE', 'TOMORROW', 'IN_ONE_WEEK', 'IN_ONE_MONTH', 'CUSTOM']);
export const Reminder = ProtoBaseModel.extend({
  scheduledAt: attr(DateTime)
});
export const Note = ProtoBaseModel.extend({
  body: attr(String),
  contactToken: attr(String),
  createdAt: attr(DateTime),
  merchantToken: attr(String),
  noteToken: attr(String),
  employee: attr(Employee),
  reminder: attr(Reminder)
});
export const DeleteNoteRequest = ProtoBaseModel.extend({
  contactToken: attr(String, {
    key: 'contact_token'
  }),
  noteV2: attr(Note, {
    key: 'noteV2'
  }),
  requestToken: attr(String, {
    key: 'request_token'
  })
}).reopenClass({
  camelizeKeys: false
});
export const DeleteNoteResponse = ProtoBaseModel.extend({
  error: attr(ProtoBaseModel.extend({
    code: attr(String),
    debugText: attr(String)
  }))
});
export const UpsertNoteRequest = ProtoBaseModel.extend({
  contactToken: attr(String, {
    key: 'contact_token'
  }),
  noteV2: attr(Note, {
    key: 'noteV2'
  }),
  requestToken: attr(String, {
    key: 'request_token'
  })
}).reopenClass({
  camelizeKeys: false
});
export const UpsertNoteResponse = ProtoBaseModel.extend({
  error: attr(ProtoBaseModel.extend({
    code: attr(String),
    debugText: attr(String)
  })),
  noteV2: attr(Note)
}).reopenClass({
  // custom deserialize function to convert noteV2 to note_v2
  deserialize(data) {
    /* eslint-disable no-param-reassign */
    data.note_v2 = data.noteV2;
    delete data.noteV2;
    /* eslint-enable no-param-reassign */

    return this._super(data);
  }
});